import { render, staticRenderFns } from "./form-connection-pt.vue?vue&type=template&id=c0d19d7e&"
import script from "./form-connection-pt.vue?vue&type=script&lang=js&"
export * from "./form-connection-pt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports